import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';

const resources = {
  en: {
    translation: en
  },
  fr: {
    translation: fr
  },
  de: {
    translation: de
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'htmlTag'],
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        if (lng && lng.includes('-')) {
          return lng.split('-')[0].toLowerCase();
        }
        return lng ? lng.toLowerCase() : 'en';
      },
      checkWhitelist: true
    },

    // S'assurer que seules nos langues supportées sont utilisées
    supportedLngs: ['en', 'fr', 'de'],
    nonExplicitSupportedLngs: false
  });

// Update document lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  // Normaliser la langue pour éviter les problèmes de casse ou de format
  const normalizedLng = lng && lng.includes('-') ? lng.split('-')[0].toLowerCase() : lng.toLowerCase();
  document.documentElement.lang = normalizedLng;
});

// Set initial lang attribute
const initialLang = i18n.language && i18n.language.includes('-') ? i18n.language.split('-')[0].toLowerCase() : i18n.language.toLowerCase();
document.documentElement.lang = initialLang;

export default i18n;